import React from 'react'
import styled from 'styled-components'
import AddIcon from '@mui/icons-material/Add'
import { font, ink, line, radius, surface, transition } from 'features/dashboard/tokens'
import EntityCard from './EntityCard'

const EntityGrid = ({
  items = [],
  canCreate = false,
  createLabel = 'New portfolio',
  onCreate,
  emptyText = 'Nothing here yet.',
  showCompliance = true,
}) => {
  const hasItems = items.length > 0

  if (!hasItems && !canCreate) {
    return <Empty>{emptyText}</Empty>
  }

  return (
    <Grid>
      {items.map(item => (
        <EntityCard key={item.key} {...item} showCompliance={showCompliance} />
      ))}
      {canCreate && (
        <CreateTile
          type='button'
          data-tour-id='portfolios.create-tile'
          onClick={() => onCreate && onCreate()}
        >
          <AddIcon style={{ fontSize: 22 }} />
          <span>{createLabel}</span>
        </CreateTile>
      )}
    </Grid>
  )
}

export default EntityGrid

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, 280px), 1fr));
  gap: 16px;
`

const CreateTile = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 110px;
  padding: 16px;
  border: 1px dashed ${line.strong};
  border-radius: ${radius.md};
  background: ${surface.wash};
  color: ${ink.mute};
  font-size: ${font.body};
  font-weight: 600;
  cursor: pointer;
  transition: ${transition};

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.primary};
    background: ${surface.linen};
  }
`

const Empty = styled.div`
  padding: 48px 24px;
  text-align: center;
  color: ${ink.mute};
  font-size: ${font.emphasis};
  border: 1px dashed ${line.base};
  border-radius: ${radius.md};
  background: ${surface.wash};
`
